import { OTPConfig } from '../model/config';
import { hideLoader, showError } from './otpUtils';

const validateGameOtpConfig = (
  gameOTPConfig: OTPConfig | undefined,
): boolean => {
  try {
    if (!gameOTPConfig) {
      throw new Error('Game OTP Config is missing');
    }

    if (gameOTPConfig.remoteApiEnable === false) {
      if (typeof gameOTPConfig.callbackFn !== 'function') {
        throw new Error(
          'Invalid callbackFn: A valid function must be provided when remoteApiEnable is false.',
        );
      }
    }

    if (gameOTPConfig.remoteApiEnable === true) {
      if (
        typeof gameOTPConfig.remoteApiEndPoint !== 'string' ||
        gameOTPConfig.remoteApiEndPoint.trim() === ''
      ) {
        throw new Error(
          'Invalid remoteApiEndPoint: A valid non-empty string must be provided when remoteApiEnable is true.',
        );
      }
    }

    return true;
  } catch (error) {
    hideLoader();
    showError('Invalid OTP configuration.', error);
    return false;
  }
};

export default validateGameOtpConfig;
